export const large = 'min-width: 1440px';
export const laptop = 'max-width: 1440px';
export const tablet = 'max-width: 1024px';
export const phone = 'max-width: 767px';
